import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class PreviousRouteService {

  private previousUrl: string;
  private currentUrl: string;
  private history: string[] = [];

  constructor(private router: Router) {
  }

  public getPreviousUrl() {
    if (this.previousUrl) {
      return this.previousUrl;
    }
    return localStorage.getItem('previousURL');
  }
  public setPreviousUrl(previousUrl) {
    localStorage.setItem('previousURL', previousUrl);
    this.previousUrl = previousUrl;
  }
  public getCurrentUrl() {
    return this.currentUrl;
  }
  public setCurrentUrl(currentUrl) {
    this.currentUrl = currentUrl;
  }

  public getHistory() {
    if (localStorage.getItem('historyURL')) {
      return JSON.parse(localStorage.getItem('historyURL'));
    }
    return this.history;
  }

  public addHistory(previousURL, newURL) {
    if (localStorage.getItem('historyURL')) {
      this.history = JSON.parse(localStorage.getItem('historyURL'));
      let index = this.history.indexOf(newURL);
      if (index > -1) {
        this.history.splice(index, this.history.length);
      } else {
        this.history.push(previousURL);
      }
      // this.history.push(item)
      localStorage.setItem('historyURL', JSON.stringify(this.history));
    } else {
      let index = this.history.indexOf(newURL);
      if (index > -1) {
        this.history.splice(index, this.history.length);
      } else {
        this.history.push(previousURL);
      }
      localStorage.setItem('historyURL', JSON.stringify(this.history))
    }
  }

  public removeCurrentHistory(item) {
    if (localStorage.getItem('historyURL')) {
      this.history = JSON.parse(localStorage.getItem('historyURL'));
      this.history.splice(this.history.indexOf(item), 1);
      localStorage.setItem('historyURL', JSON.stringify(this.history));
    } else {
      this.history.splice(this.history.indexOf(item), 1);
      localStorage.setItem('historyURL', JSON.stringify(this.history));
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/previous-route.service.ts